(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["avh-bundle-shop"] && !Shopify.designMode) return;
  try {
    
function setupBundleShops(){document.querySelectorAll('[data-bundle-shop]').forEach(root=>{if(root.dataset.initialized)return;root.dataset.initialized='true';const cards=[...root.querySelectorAll('[data-bundle-card]')];const tabs=[...root.querySelectorAll('button[data-texture]')];const seen=new Set();cards.forEach(card=>{if(seen.has(card.dataset.product))card.remove();else seen.add(card.dataset.product)});function filter(value){let shown=0;root.querySelectorAll('[data-bundle-card]').forEach(card=>{const matches=value==='all'||card.dataset.texture===value;card.hidden=!matches||shown>=4;if(matches)shown++});tabs.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.texture===value)))}tabs.forEach(button=>{button.disabled=button.dataset.texture!=='all'&&!cards.some(card=>card.dataset.texture===button.dataset.texture);button.addEventListener('click',()=>{filter(button.dataset.texture);root.querySelector('.avh-bundles__head').scrollIntoView({block:'start',behavior:'smooth'})})});filter('all')})}setupBundleShops();document.addEventListener('shopify:section:load',setupBundleShops);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["simple-hero"] && !Shopify.designMode) return;
  try {
    
  const initializeAvhStoryHeroes = (root = document) => {
    root.querySelectorAll('[data-avh-story-hero]').forEach((hero) => {
      if (hero.dataset.initialized === 'true') return;
      hero.dataset.initialized = 'true';

      const slides = [...hero.querySelectorAll('[data-story-slide]')];
      const tabs = [...hero.querySelectorAll('[data-story-tab]')];
      const previous = hero.querySelector('[data-story-previous]');
      const next = hero.querySelector('[data-story-next]');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let current = 0;
      let timer;

      const show = (index) => {
        current = (index + slides.length) % slides.length;
        slides.forEach((slide, slideIndex) => slide.setAttribute('aria-hidden', String(slideIndex !== current)));
        tabs.forEach((tab, tabIndex) => tab.setAttribute('aria-selected', String(tabIndex === current)));
      };

      const stop = () => window.clearInterval(timer);
      const start = () => {
        stop();
        if (hero.dataset.autoplay === 'true' && !reducedMotion) {
          timer = window.setInterval(() => show(current + 1), Number(hero.dataset.interval));
        }
      };

      tabs.forEach((tab, index) => tab.addEventListener('click', () => {
        show(index);
        start();
      }));
      previous.addEventListener('click', () => {
        show(current - 1);
        start();
      });
      next.addEventListener('click', () => {
        show(current + 1);
        start();
      });
      hero.addEventListener('mouseenter', stop);
      hero.addEventListener('mouseleave', start);
      hero.addEventListener('focusin', stop);
      hero.addEventListener('focusout', start);
      start();
    });
  };

  initializeAvhStoryHeroes();
  document.addEventListener('shopify:section:load', (event) => initializeAvhStoryHeroes(event.target));

  } catch(e) { console.error(e); }
})();
})();
